import { Unit } from "uom";
// Text
// export const Text = _register(Unit.createProductUnit<q.Text>("Text", []), " ");
export var Text = Unit.createBase("Text", "Text", " ");
//# sourceMappingURL=text.js.map